import { RoadworkDto } from "../services/bbo-client.service";
import { Road, RoadDirection } from "./road.model";

export const ROADWORK_MARKERS_PANE = "roadworks";
export const HIGHLIGHTED_ROADWORK_MARKER_PANE = "highlighted-roadwork";

export enum RoadworkCitsState {
	Assigned = "ZUGEORDNET",
	Unassigned = "NICHT ZUGEORDNET",
	ExaminationNeeded = "PRÜFUNG ERFORDERLICH",
	NotAssignable = "NICHT ZUORDENBAR",
	Closed = "ABGESCHLOSSEN",
	Interrupted = "PAUSIERT",
}

export class Roadwork {
	id: string;
	roadworksReferenceId: number;
	phaseReferenceId: number;
	type: string;
	name?: string;
	lat: number;
	lon: number;
	purviewNames: string[];
	phaseDateStart: string;
	phaseDateEnd: string;
	dateStart: string;
	dateEnd: string;
	roadCode: string;
	beginInterchangeName: string;
	endInterchangeName: string;
	beginMeter: number;
	endMeter: number;
	phaseStateId: number;
	citsState: RoadworkCitsState;
	validityTime: string;
	regulationPeriod: string;
	vacatable: boolean;
	road?: Road;
	direction?: RoadDirection;
	areCoordinatesManuallySet?: boolean;
	belongsToCurrentUser: boolean;

	constructor(res: RoadworkDto, correspondingRoad?: Road) {
		this.id = res.id as string;
		this.roadworksReferenceId = res.roadworksReferenceId as number;
		this.phaseReferenceId = res.phaseReferenceId as number;
		this.lat = res.lat as number;
		this.lon = res.lon as number;
		this.phaseDateStart = res.phaseDateStart as string;
		this.phaseDateEnd = res.phaseDateEnd as string;
		this.dateStart = res.roadworkDateStart as string;
		this.dateEnd = res.roadworkDateEnd as string;
		this.roadCode = res.route as string;
		this.beginMeter = res.beginMeter as number;
		this.endMeter = res.endMeter as number;
		this.vacatable = res.vacatable as boolean;
		this.phaseStateId = res.phaseStateId as number;
		this.citsState = res.citsState as RoadworkCitsState;
		this.type = res.roadworkType as string;
		this.name = res.roadworkName;
		this.purviewNames = res.abm?.split("|") ?? [];
		this.beginInterchangeName = res.beginInterchangeName as string;
		this.endInterchangeName = res.endInterchangeName as string;
		this.validityTime = res.validityTime as string;
		this.regulationPeriod = res.regulationPeriod as string;
		this.road = correspondingRoad;
		this.direction = correspondingRoad?.DirectionOptions.find((d) => d.id == res.direction);
		this.areCoordinatesManuallySet = res.areCoordinatesManuallySet;
		this.belongsToCurrentUser = !!res.belongsToCurrentUser;
	}

	get PopupData(): this {
		return this;
	}

	get CitsStateTranslationName(): string {
		switch (this.citsState) {
			case RoadworkCitsState.Assigned:
				return "cits-state.assigned";
			case RoadworkCitsState.Closed:
				return "cits-state.closed";
			case RoadworkCitsState.Unassigned:
				return "cits-state.unassigned";
			case RoadworkCitsState.ExaminationNeeded:
				return "cits-state.examinationneeded";
			case RoadworkCitsState.NotAssignable:
				return "cits-state.notassignable";
			case RoadworkCitsState.Interrupted:
				return "cits-state.interrupted";
			default:
				return "cits-state.notassignable";
		}
	}

	get CitsStateCssClass(): string {
		switch (this.citsState) {
			case RoadworkCitsState.Assigned:
				return "cits-assigned";
			case RoadworkCitsState.Closed:
				return "cits-closed";
			case RoadworkCitsState.Unassigned:
				return "cits-unassigned";
			case RoadworkCitsState.ExaminationNeeded:
				return "cits-examinationneeded";
			case RoadworkCitsState.NotAssignable:
				return "cits-notassignable";
			default:
				return "cits-notassignable";
		}
	}

	get VacatableTranslationName(): string {
		return this.vacatable ? "vacatable" : "not-vacatable";
	}

	get StartKm(): number {
		return this.beginMeter / 1000;
	}

	get EndKm(): number {
		return this.endMeter / 1000;
	}
}
